import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import * as feather from 'feather-icons';
import { take, timer } from 'rxjs';
import { NavService } from 'src/app/shared/services/nav.service';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { SidebarComponent } from 'src/app/shared/components/sidebar/sidebar.component';
import { TimerDisplayComponent } from 'src/app/shared/components/timer-display/timer-display.component';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, TimerDisplayComponent],
})
export class ContentComponent implements AfterViewInit {
  constructor(
    public navServices: NavService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  closeSidebar = () => this.navServices.closeSidebar();

  ngAfterViewInit(): void {
    timer(0)
      .pipe(take(1))
      .subscribe(() => {
        feather.replace();
        this.changeDetectorRef.detectChanges();
      });
  }

  activateEvents(e) {
    this.changeDetectorRef.detectChanges();
  }
}
